import {
  useQuery,
  ExtractFnReturnType,
  QueryConfigType,
  UseQueryResult,
} from "~/libs";

import { ApiClient, ApiResponseError } from "~/utils";

import { ApiManagersLeftEmployeesEditResponseType } from "~/domains";

type ParamsType = {
  id: string;
};

const request = async ({
  id,
}: ParamsType): Promise<ApiManagersLeftEmployeesEditResponseType> => {
  const response =
    await new ApiClient().get<ApiManagersLeftEmployeesEditResponseType>(
      `/api/managers/left_employees/${id}/edit`,
    );
  return response.data;
};

type QueryFnType = typeof request;

type PropsType = {
  id: string;
  config?: QueryConfigType<QueryFnType>;
};

export const useApisManagersLeftEmployeesEdit = ({
  id,
  config = {},
}: PropsType): UseQueryResult<ApiManagersLeftEmployeesEditResponseType> => {
  return useQuery<ExtractFnReturnType<QueryFnType>>({
    ...config,
    queryKey: ["ApisManagersLeftEmployeesEdit", id],
    queryFn: () => request({ id }),
    useErrorBoundary: (error) => {
      return error instanceof ApiResponseError && error.status >= 500;
    },
  });
};
